import React from 'react';
import axios from 'axios';
import {tsDateToServer} from  '../../../../services/process/migrations/migrationService.js';
import { useState } from 'react';


function TwentySixASRecon({hidden})
{
    const [date, setDate] = useState('');
    const [dateHidden, setDateHidden] = useState(true);

    function tsasClick(e){
        let payload = {
            name: "Recently Data Uploaded Date"
        }

        var tsDate = tsDateToServer();
        // console.log("brsCredentials", detaildInvoce);

        axios.post(tsDate[1], payload, tsDate[0])
        .then(
            response => {
                console.log("Getting Approved TSAS Details!!!", response);
                let responseData = response["data"]; 
                console.log("responseData", responseData);
                if (responseData["Status"] === "Success")
                {
                    let tsAsDate = responseData["tdsUploadedDate"];
                    // let brsDetails = responseData["brsCount"]; 
                    
                    // sessionStorage.setItem("userCredentials", JSON.stringify(userCredentials));
                    // navigate(userCredentials["config"]["default_page"]);
                    console.log("tsAsDate", tsAsDate);
                    setDate(tsAsDate["data"][0]["date"]);
                    setDateHidden(false);
                    // setApproverName(approverDetails["data"][0]["approved_by"]);
                    // setApprovedOn(approverDetails["data"][0]["approved_date"]);
                    // if (approverDetails["data"].length > 0){
                    //     setApproverHidden(false);
                    // }
                    // else{
                    //     setApproverHidden(true);
                    // }
                        
                    // getBankList();
                    // setRowData(detailedInvoice["data"]);
                    // setColumnData(detailedInvoice["headers"]);
                    // setInvoiceGridHidden(false);
                }
            }
        ).catch(
            error => {
                console.log("Error", error);
                alert("Error in Getting TSAS Details!!!");
            }
        );
    };

    return (
        <>
            <div hidden={hidden}>
                <div className="vendorchartbox1">
                    <div className="vendorchart-box-layer">
                        <table style={{width:"70%",marginTop:"-11px", marginLeft: "-30%"}}>
                            
                            <tbody>
                                <tr>
                                    <td><button style={{textAlign: "center",  border: ".1px solid #000055", color: "#ffffff", padding:"4px 16px", borderRadius: "15px", backgroundColor: "#024f9d"}} onClick={tsasClick}>
                                        Load
                                    </button>&nbsp;</td>
                                </tr>
                                
                            </tbody>
                        
                        </table>
                        <div hidden={dateHidden}>
                            <p style={{marginTop:"-2.5%"}}><h5>Recently Data Uploaded Date : {date}</h5></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default  TwentySixASRecon;